import React, {Component} from "react"
import ReactDOM from "react-dom"
import {convertToDisplayFormat, parse} from "../../../util/DateUtil"
import {queryEnterpriseAccount} from "../../../dispatch"
import op from "object-path"
import moment from "moment"
import {connect} from "react-redux"
import Highlighter from "react-highlight-words";
import {routerActions} from "react-router-redux"
import Spinner from "../../../components/Spinner"
import Alert from "../../../components/Alert"
import "datatables.net"
import "datatables.net-bs"
import 'datatables.net-responsive'
import 'datatables.net-fixedheader-bs'
import 'datatables.net-fixedheader-bs/css/fixedHeader.bootstrap.min.css'
import 'datatables.net-fixedcolumns-bs'
import 'datatables.net-fixedcolumns-bs/css/fixedColumns.bootstrap.min.css'
import "datatables.net-buttons/js/dataTables.buttons"
import "datatables.net-buttons/js/buttons.html5"
import "../../../../themes/inspinia/js/plugins/dataTables.buttons/css/buttons.bootstrap.min.css"
import "datatables.net-bs/css/dataTables.bootstrap.css"
import ApplicationIcon from "../../../components/ApplicationIcon"
import {Badge, OverlayTrigger, Popover, ProgressBar} from "react-bootstrap"
import OpenCollapseToggle from "../../../components/OpenCollapseToggle"
import Button from "../../../components/Button"
import Select from 'react-select'
import EnterpriseAccountWithLicenseUpdateModal from "./EnterpriseAccountWithLicenseUpdateModal"
import {COLOR_NEGATIVE, COLOR_VERY_NEGATIVE} from "../../../constants"

let search = ''

const TABLE_ID = 'enterpriseAccountsTable'

function mapStateToProps(state, ownProps) {

  return {
    selectedAccount: state.enterpriseAccount
  }

}

const mapDispatchToProps = {
  push: routerActions.push,
  queryEnterpriseAccount
}

let dataMap = {}

const getData = (list = []) => (list.map((it) => {

  const accountManager = it.accountManager || "N/A"
  const license = it.licenses && it.licenses.length > 0 ? it.licenses[0] : {applications: [], emails: [], limit: 0}
  const autherrizedUserEmails = it.authorizedUsers.map(u => u.emailAddress)
  const autherizedUserEmailSet = new Set(autherrizedUserEmails)
  const licenseEmailSet = new Set(license.emails)
  const data = [
    it.id,
    it.name,
    convertToDisplayFormat(it.dateCreated),
    accountManager,
    {
      activeUsers: it.authorizedUsers.filter(u => licenseEmailSet.has(u.emailAddress)),
      inactiveUsers: it.authorizedUsers.filter(u => !licenseEmailSet.has(u.emailAddress)),
      staff: it.staff
    },
    `${license.emails.length}/${license.limit}`,
    license.applications,
    null,
    license.expirationDate
  ]
  dataMap[it.id] = data
  return data
}))

const AccountUsers = (props) => {

  const {data, search} = props

  const highlight = (s) => (
    <Highlighter
      highlightClassName="highlight"
      searchWords={[search]}
      autoEscape={true}
      textToHighlight={s}
    />
  )

  const userLabels = (users) => {
    const options = users.map((u) => ({value: u.id, label: highlight(u.emailAddress)}))
    return (
      <Select
        multi
        disabled
        value={options}
        options={options}/>
    )
  }
  return (
    <div className="white-bg">
      <div className="row">
        <div className="col-xs-2 text-right p-xs">
          <h4>Enterprise Manager(s)</h4>
        </div>
        <div className="col-xs-6 p-xs">
          {userLabels(data.staff)}
        </div>
      </div>


      <div className="row">
        <div className="col-xs-2 text-right p-xs">
          <h4>Active User(s) <Badge>{data.activeUsers.length}</Badge></h4>

        </div>
        <div className="col-xs-6 p-xs">
          {userLabels(data.activeUsers)}
        </div>
      </div>


      <div className="row">
        <div className="col-xs-2 text-right p-xs">
          <h4>Inactive User(s) <Badge>{data.inactiveUsers.length}</Badge></h4>

        </div>
        <div className="col-xs-6 p-xs">
          {userLabels(data.inactiveUsers)}

        </div>
      </div>
    </div>
  )
}


const renderTable = (list, tableId, push, queryEnterpriseAccount, openModal) => {

  const getDiff = (date)=>(date ? date.diff(moment(), 'days') : null)
  const checkExpirationStatus = (diff)=>{
    if(_.isNil(diff)) return null
    else if(diff >= 0 && diff < 15) return 'expiring'
    else if(diff < 0) return 'expired'
    else return null
  }

  const table = $('#' + tableId).DataTable({
    data: getData(list),
    responsive: true,
    searchDelay: 400,
    // scrollY: "300px",
    scrollX: true,
    scrollCollapse: true,
    fixedHeader: {
      header: true,
      footer: false
    },
    "columnDefs": [
      {
        "targets": 7,
        "data": null,
        "createdCell": function (td, data, rowData, row, col) {
          const component = (
            <Button style="admin" className="updateButton">
              <i className="fa fa-pencil-alt"></i>
            </Button>
          )
          ReactDOM.render(component, td)
        },
        "render": function (data, type, row, meta) {
          return `<a class='updateButton btn btn-admin'>
                      <i class="fa fa-edit" ></i>
                    </a>`

        }
      },
      {
        "targets": 4,
        "data": (row, type, set, meta) => {
          const userDetails = row[4]
          if (type === 'filter') {
            return _.map(_.concat(userDetails.staff, userDetails.activeUsers, userDetails.inactiveUsers), 'emailAddress').join(' ')
          } else return row
        },
        "createdCell": function (td, data, rowData, row, col) {

          const total = data[4].activeUsers.length + data[4].inactiveUsers.length
          const percentage = total !== 0 ? Math.round(data[4].activeUsers.length * 100 / (total)) : 0

          const component = (
            <table className="full-width">
              <tr>
                <td style={{paddingTop: '5px'}}>
                  <p>{data[4].activeUsers.length}/{data[4].inactiveUsers.length}</p>
                </td>
                <td>
                  <div className='userDetailsButton pull-right'>
                    <h3><OpenCollapseToggle/></h3>
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <ProgressBar style={{height: '5px'}} bsStyle="neeuro" now={percentage}/>
                </td>
              </tr>
            </table>)
          ReactDOM.render(component, td)

        }
      },
      {
        "targets": 6,
        "data": null,
        "createdCell": function (td, cellData, rowData, row, col) {
          ReactDOM.render(<div>
            {cellData[6].map(app => <ApplicationIcon className="m-l-xs m-b-xs" application={app}/>)}
          </div>, td)


        }
      },
      {
        "targets": 8,
        "data": (row, type, set, meta) => {
          const expirationDate = row[8] ? parse(row[8]) : null
          const diff = getDiff(expirationDate)
          const status = checkExpirationStatus(diff)

          if (type === 'sort') {
            // return status === 'expiring' || status === 'expired' ? diff : Number.MIN_SAFE_INTEGER
            return status

          } else return row

        },
        "createdCell": function (td, cellData, rowData, row, col) {

          const expirationDate = cellData[8] ? parse(cellData[8]) : null
          const diff = getDiff(expirationDate)
          const status = checkExpirationStatus(diff)

          const title = status === 'expiring'?"Expiring Licenses":"Expired Licenses"
          const desc = status === 'expiring'?
            `This Enterprise Account has licenses expiring in the next ${diff} days.`
            :
            `This Enterprise Account has licenses expired for ${diff*-1} days.`

          const popover = (
            <Popover title={title}>
              {desc}
            </Popover>
          );

          const alert =(
            <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
              <i className="fa fa-exclamation-triangle fa-lg" style={{color: status === 'expiring'?COLOR_NEGATIVE:COLOR_VERY_NEGATIVE}}/>
            </OverlayTrigger>
            )

          ReactDOM.render(<div className="m-t-xs text-center">
            {status? alert : ''}
          </div>, td)


        }
      }
    ],
    "pagingType": "full_numbers",
    order: [[2, 'desc']],
    pageLength: 20
  });

  $(`#${tableId} tbody`).on('click', '.updateButton', function () {
    var data = table.row($(this).parents('tr')).data();
    const id = data[0]
    queryEnterpriseAccount(id)
    openModal()
    // const path = `/admin/enterprise/account/${id}`
    // push(path)
  });

  let count = 0

  const closeAllChildRows = () => {
    table.rows().eq(0).each(function (idx) {
      const row = table.row(idx);

      if (row.child.isShown()) {
        $(row.node()).find('.open-collapse-toggle').trigger('click')
        // row.child.hide();
      }
    })

    // count = 0
    // $('.DTFC_RightWrapper').show()

  }

  table.on('search.dt', function () {
    search = table.search()
    closeAllChildRows()
  });

  /*var fixedColumns = new $.fn.dataTable.FixedColumns(table, {
    leftColumns: 0,
    rightColumns: 2
  });*/


  const userDetailsControl = function () {

    var tr = $(this).parents('tr')
    var row = table.row(tr);

    if (row.child.isShown()) {
      // This row is already open - close it
      row.child.hide();
      tr.removeClass('shown');

      count--
      if (count === 0) $('.DTFC_RightWrapper').show();

    } else {

      // Open this row
      const component = <AccountUsers data={row.data()[4]} search={search}/>
      row.child(`<div class="accountUserDetails"></div>`).show()
      const td = row.child().find('.accountUserDetails').get(0)
      ReactDOM.render(component, td)
      tr.addClass('shown');

      count++
      if (count > 0) $('.DTFC_RightWrapper').hide();
    }
  }

  $(`#${tableId} tbody`).on('click', '.userDetailsButton', userDetailsControl);
}

const updateTable = (list = [], tableId) => {

  $('#' + tableId).DataTable().clear()
  $('#' + tableId).DataTable().rows.add(getData(list)).draw()
}

class EnterpriseAccountTable extends Component {

  constructor() {
    super()
    this.state = {
      openAccountModal: false
    }
  }

  componentDidMount() {

    const {push} = this.props

    const tableId = TABLE_ID
    renderTable(op.get(this.props.data, 'data', []), tableId, push,
      this.props.queryEnterpriseAccount,
      () => {
        this.setState({openAccountModal: true})
      }
    )

    setTimeout(() => {
      $(`#${tableId}`).DataTable().columns.adjust().draw()
    }, 1000)
  }

  componentWillReceiveProps(nextProps) {
    const tableId = TABLE_ID
    updateTable(op.get(nextProps.data, 'data', []), tableId)
  }

  render() {
    const tableId = TABLE_ID
    const loading = op.get(this.props.data, 'loading', false)
    const error = op.get(this.props.data, 'error')

    return (
      <div>
        <EnterpriseAccountWithLicenseUpdateModal
          show={this.state.openAccountModal}
          onHide={(shouldRefresh) => {
            this.setState({openAccountModal: false})
            if (shouldRefresh) {
              setTimeout(() => {
                location.reload(true)
              }, 500)
            }

          }}
          enterpriseAccount={this.props.selectedAccount}/>
        <Spinner show={loading}/>
        <Alert show={error} message={error ? error.message : ""}/>
        <table width="100%" className="table table-striped table-bordered table-hover dataTables-example" id={tableId}>
          <thead>
          <tr>

            <th>ID</th>
            <th>Name</th>
            <th>Date Created</th>
            <th>Account Manager</th>
            <th>Active/Inactive Users</th>
            <th>License Used</th>
            <th>Applications</th>
            <th></th>
            <th></th>

          </tr>
          </thead>
          <tbody>
          </tbody>
        </table>

      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EnterpriseAccountTable)



// WEBPACK FOOTER //
// ./src/routes/admin/components/EnterpriseAccountTable.js